"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStopWorkflowMessage = exports.setStopAndFilterWorkflowMessage = exports.isExceptionMessage = exports.setMessageException = exports.getMessageExceptionType = exports.getMessageExceptionDescription = exports.filterWorkflowSchema = exports.exceptionSchema = void 0;
var schemas_1 = require("@augloop/schemas/dist/src/client/schemas");
exports.exceptionSchema = {
    category: schemas_1.TypeCategory.Schema,
    schema: {
        name: 'Exception',
        path: 'message-schema.proto'
    }
};
exports.filterWorkflowSchema = {
    category: schemas_1.TypeCategory.Schema,
    schema: {
        name: 'Filter',
        path: 'message-schema.proto'
    }
};
exports.getMessageExceptionDescription = function (message, verbose) {
    if (verbose === void 0) { verbose = false; }
    if (message == null) {
        return 'Invalid message passed';
    }
    else if (message.payload == null) {
        return schemas_1.ExceptionType[schemas_1.ExceptionType.NoOutput] + ": Payload is null";
    }
    else if (message.payload.exceptionType == null) {
        return 'Payload is not an exception';
    }
    else {
        var description = schemas_1.ExceptionType[message.payload.exceptionType]; // Exception type
        description += message.payload.message ? ": " + message.payload.message : ': No description'; // Exception message
        description += (verbose && message.payload.data) ? "\n" + message.payload.data.toString() : ''; // Exception data
        return description;
    }
};
exports.getMessageExceptionType = function (message) {
    if (message == null || message.payload == null || message.payload.exceptionType == null) {
        return schemas_1.ExceptionType.Unknown;
    }
    return message.payload.exceptionType;
};
exports.setMessageException = function (message, error) {
    if (message == null) {
        throw new Error('Cannot set exception on null message');
    }
    message.payload = error;
    message.payloadSchema = exports.exceptionSchema;
    message.messageType = schemas_1.MessageType.Exception;
};
exports.isExceptionMessage = function (message) {
    if (message == null || message.messageType == null) {
        return true;
    }
    return (message.messageType == schemas_1.MessageType.Exception);
};
exports.setStopAndFilterWorkflowMessage = function (message, filter) {
    if (message == null) {
        throw new Error('Cannot set filter on null message');
    }
    var filterMessage = {
        condition: filter
    };
    message.payload = filterMessage;
    message.payloadSchema = exports.filterWorkflowSchema;
    message.messageType = schemas_1.MessageType.StopAndFilterWorkflow;
};
exports.isStopWorkflowMessage = function (message) {
    return (message || {}).messageType == schemas_1.MessageType.StopAndFilterWorkflow;
};
//# sourceMappingURL=imessage.js.map